import React from "react";


export default function Content() {
  return (
    <>
    <section class="text-gray-600 body-font">
    <div class="flex flex-col text-center w-full mb-20">
     
     <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Benefits Of Choosing Flutter For Your Company

</h1>
    
   </div>
  <div class="container px-5 py-24 mx-auto flex flex-wrap">
    <div class="lg:w-1/2 w-full mb-10 lg:mb-0 rounded-lg overflow-hidden">
      <img alt="feature" class="object-cover object-center mt-20-px h-300 w-300" src="https://engineerbabu.com/img/new/flutter/flutter_benefit.png"/>
    </div>
    <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp; Fast & Seamless</h2>
          <p class="leading-relaxed text-base text-gray-900">Flutter is a great choice for anyone looking to build an app as it has a simple development process. Flutter's Hot Reload feature prevents any delay in applying changes and reflects them on your app instantly.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Cost-Effective</h2>
          <p class="leading-relaxed text-base text-gray-900">Flutter makes it easier for developers to debug programs by allowing them to change the code and analyze the results themselves. This makes Flutter one of the most cost-effective frameworks to build your app on.</p>
         
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;UI Uniformity On All Platforms</h2>
          <p class="leading-relaxed text-base text-gray-900">You don't need to have UI components specific to a platform to design the interface on Flutter. No other application framework, besides Flutter, caters to a cross-platform UI code.</p>
          
        </div>
      </div>
      <div class="flex flex-col mb-10 lg:items-start items-center">
        
        <div class="flex-grow">
          <h2 class="text-gray-900 text-lg title-font font-medium mb-3">● &nbsp;Accelerated Time-To-Launch</h2>
          <p class="leading-relaxed text-base text-gray-900">Since you don't need to develop separate apps for Android and iOS, Flutter usually takes lesser time to launch your app. Additionally, Flutter comes with a declarative framework to change UI, which makes app development faster.</p>
        </div>
      </div>
    </div>
  </div>
</section>
    </>
  );
}